import { useState, useRef } from "react";
import { ReactComponent as InterviewAILogo } from "../../assets/icons/InterviewAILogo.svg";
import { ReactComponent as UserLogo } from "../../assets/icons/UserLogo.svg";
import StudentProfile from "./StudentProfile";
import "./Style.css";

const StudentPageHeader = ({ userDetail }) => {
  const [showProfile, setShowProfile] = useState(false);
  const profileButtonRef = useRef(null);
  
  return (
    <div className="student-page-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-4">
            <InterviewAILogo className="h-10 w-10" />
            <div>
              <h1 className="text-xl font-bold text-white">InterviewAI</h1>
              <p className="text-sm text-white">Student Dashboard</p>
            </div>
          </div>
          <div className="flex items-center space-x-4 relative">
            <div
              ref={profileButtonRef}
              onClick={() => setShowProfile(!showProfile)}
              className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg hover:bg-white hover:bg-opacity-10 transition-all"
            >
              <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                <UserLogo className="text-white" />
              </div>
              <span className="text-sm font-medium text-white">{userDetail?.student_name}</span>
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            {showProfile && (
              <StudentProfile
                userDetail={userDetail}
                onClose={() => setShowProfile(false)}
                buttonRef={profileButtonRef}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentPageHeader;
